import { useQuery } from "@tanstack/react-query";
import { apiRelFichaProdutor } from "pages/relatorios/api/apiRelFichaProdutor";
import { RelatorioContainer } from "pages/relatorios/components/RelatorioContainer";
import { useRelatorioStore } from "pages/relatorios/store";
import type { ApiRelatorioGetParams } from "pages/relatorios/types/ApiRelatorioParams";
import { buildRelatorioGetParams } from "pages/relatorios/utils/buildRelatorioGetParams";
import { useEffect, useMemo } from "react";
import { FilterBar } from "./FilterBar";
import { TableRelFichaProdutor } from "./TableRelFichaProdutor";

export function RelatorioFichaProdutor() {
	const filter = useRelatorioStore((s) => s.filter);

	const limparFiltros = useRelatorioStore((s) => s.limparFiltros);

	const params: ApiRelatorioGetParams = useMemo(() => buildRelatorioGetParams(filter), [filter]);

	const { data, isFetching, refetch } = useQuery({
		queryKey: ["apiRelFichaProdutor", params],
		queryFn: () => apiRelFichaProdutor({ params }),
		enabled: false,
	});

	const registros = useMemo(() => data?.registros || [], [data]);

	useEffect(() => {
		limparFiltros();
	}, [limparFiltros]);

	const title = "Dados da Ficha do Produtor";

	return (
		<RelatorioContainer
			breadCrumbs={["Relatórios", "Ficha", "Produtor"]}
			refetch={refetch}
			filterBar={<FilterBar />}
			loading={isFetching}
			title={title}
			registros={registros}
			table={<TableRelFichaProdutor data={data?.registros} title={title} />}
		/>
	);
}
